module.exports = __webpack_public_path__ + "img/imgfftBR100.679263c5.png";